<template>
  <div>
    <loading-spinner v-if="isLoading" />
    <div class="col-12 mb-4">
			<span class="back-btn" @click="$emit('setCurrentTab','SupplierInformationForExceptionRequest')">
				<font-awesome-icon icon="arrow-left" size="sm"/>
				Back to supplier information
			</span>
    </div>

    <div class="row mt-4">

      <div class="col-md-12 col-12 form-field">
        <div class="col-12">
          <p>
            Please preview the details you've provided and scroll down to submit.
          </p>
          <div class="title-text font-weight-bold">
            General information
          </div>
          <div class="row my-2">
            <div class="col-12 col-md-6 mt-3">
              <div class="form-text">Requested by</div>
              <div class="preview-text">{{ previewRequestedByFullName }}</div>
            </div>
            <div
                class="col-12 col-md-6 mt-3 px-0"
                v-if="exceptionSubmissionRequestData.requestedFor"
            >
              <div class="form-text">Requested for</div>
              <div class="preview-text">{{ previewRequestedForFullName }}</div>
            </div>

            <div
                class="col-12 col-md-6 mt-3"
                v-if="exceptionSubmissionRequestData.watchers && exceptionSubmissionRequestData.watchers.length > 0"
            >
              <div class="form-text">Watchers</div>
              <div class="preview-text">{{ watcherList }}</div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="container-fluid">
            <div class="row">
              <Detail
                  class="col-md-6 col-12"
                  position="1"
                  name="Request type"
                  :description="filteredRequestFor"
              />

              <Detail v-if="filteredRequestFor === requestForMap.SPONSORSHIP"
                      class="col-md-6 col-12"
                      position="1 a"
                      :name="requestForCheckBoxText.SPONSORSHIP_TEXT"
                      :description="exceptionSubmissionRequestData.stepsCompletedForSponsorship | yesno"
              />

              <Detail v-if="filteredRequestFor === requestForMap.CORPORATE_DONATION"
                      class="col-md-6 col-12"
                      position="1 a"
                      :name="requestForCheckBoxText.CORPORATE_DONATION_TEXT"
                      :description="exceptionSubmissionRequestData.stepsCompletedForCorporateDonation | yesno"
              />

              <Detail v-if="filteredRequestFor === requestForMap.SPEAKER"
                      class="col-md-6 col-12"
                      position="1 a"
                      :name="requestForCheckBoxText.SPEAKER_TEXT"
                      :description="exceptionSubmissionRequestData.approvalAgreementAvailableForSpeaker | yesno"
              />

              <Detail v-if="displayGenericCheckBox(filteredRequestFor)"
                      class="col-md-6 col-12"
                      position="1 a"
                      :name="requestForCheckBoxText.GENERIC_CHECKBOX_TEXT"
                      :description="exceptionSubmissionRequestData.necessaryStepsAndSupportingDocumentationCompleted | yesno"
              />

              <Detail v-if="filteredRequestFor === requestForMap.OTHER"
                      class="col-md-6 col-12"
                      position="1 a"
                      :name="requestForCheckBoxText.OTHER_TEXT"
                      :description="exceptionSubmissionRequestData.additionalDescription"
              />

              <Detail
                  class="col-md-6 col-12"
                  position="2"
                  name="Brief description"
                  :description="exceptionSubmissionRequestData.briefDescription"
              />

              <Detail
                  class="col-md-6 col-12"
                  position="3"
                  name="What Autodesk company is buying these services / this product?"
                  :description="previewMultiSelectOptions"
              />
              <Detail
                  class="col-md-6 col-12"
                  position="4"
                  name="Was this supplier suggested or recommended by a government official, or will this supplier engagement involve any of the following: (a) lobbying or of consulting on government affairs; (b) interacting with government officials on Autodesk’s behalf; or (c) services involving a government official?"
                  :description="exceptionSubmissionRequestData.recommendedByGovernment | yesno"
              />
              <Detail
                  class="col-md-6 col-12"
                  position="5"
                  name="Will this supplier engagement involve them interacting with Autodesk customers on our behalf?"
                  :description="exceptionSubmissionRequestData.onBehalfOfAutodeskCustomer | yesno"
              />

              <Detail
                  class="col-md-6 col-12"
                  position="6"
                  name="Do you or, to your knowledge, does anyone else at Autodesk have a relationship with the supplier or an employee of the supplier that must be disclosed and vetted under our Conflicts of Interest Policy?"
                  :description="exceptionSubmissionRequestData.anyRelationshipWithAutodesk | yesno"
              />

              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 title-text font-weight-bold">
                    Supplier information
                  </div>
                  <Detail
                      class="col-12"
                      position="7"
                      name="Approximate spend"
                      :description="exceptionSubmissionRequestData.approximateSpend"
                  />
                  <Detail
                      class="col-md-6 col-12"
                      position="8"
                      name="Supplier name"
                      :description="exceptionSubmissionRequestData.supplierName"
                  />
                  <Detail
                      class="col-md-6 col-12"
                      position="8. a"
                      name="URL for supplier’s website"
                      :description="exceptionSubmissionRequestData.supplierWebsite"
                      :capitalize="false"
                  />
                  <Detail
                      class="col-md-6 col-12"
                      position="8. b"
                      name="Supplier contact name"
                      :description="exceptionSubmissionRequestData.supplierContactName"
                  />
                  <Detail
                      class="col-md-6 col-12"
                      position="8. c"
                      name="Supplier contact role"
                      :description="
							getPreviewText(supplierContactRoleOptions, 'supplierContactRole')
						"
                  />
                  <Detail
                      class="col-md-6 col-12"
                      position="8. d"
                      name="Supplier email"
                      :description="exceptionSubmissionRequestData.supplierContactEmail"
                      :capitalize="false"
                  />
                  <Detail
                      class="col-md-6 col-12"
                      position="8. e"
                      name="Supplier country"
                      :description="exceptionSubmissionRequestData.supplierCountry"
                  />
                  <Detail
                      class="col-md-6 col-12"
                      position="9. "
                      name="corporateCardType"
                      :description="exceptionSubmissionRequestData.corporateCardType"
                  />
                  <div class="col-12 px-0 w-100">
                    <preview-attachments :filteredFormData="exceptionSubmissionRequestData" :viewAttachment="false"/>
                  </div>
                </div>
              </div>



              <div class="col-12 px-xl-0 mt-4">
                <div
                    class="d-flex flex-column align-items-center justify-content-xl-end flex-xl-row"
                >
                  <button
                      class="flat-btn gray-btn close-btn btn mx-2 my-3"
                      @click="navigateToHome"
                      :disabled="isLoading"
                  >
                    Cancel
                  </button>
                  <button
                      class="btn primary-blue-btn flat-btn mt-2 mt-xl-0 ml-xl-2"
                      @click="saveExceptionSubmissionRequest()"
                      :disabled="isLoading"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Detail from "@/components/OneIntakeForm/PreviewDetails/Detail";
import CONSTANTS from "@/store/constants";
import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";
import PreviewAttachments from "@/components/Payments/PreviewAttachments";
import LoadingSpinner from "@/components/LoadingSpinner";
import exceptionRequestMixin from "@/mixins/exceptionRequestMixin";
import supplierRequestMixin from "@/mixins/supplierRequestMixin";

export default {
  name: "PreviewDetailsForExceptionRequest",
  mixins: [exceptionRequestMixin,supplierRequestMixin],
  components: {
    Detail,
    PreviewAttachments,
    LoadingSpinner
  },
  filters: {
    yesno: function (value) {
      //Specifically checking if the options selected were Yes/No , if not answered then "N/A", to be used.
      if (value) {
        return "Yes"
      } else if (value === false) {
        return "No"
      } else return "N/A"
    },
    yesnodontknow: function (value) {
      if (value) {
        return CONSTANTS.ONE_INTAKE_RADIO_OPTIONS.find(option => option.text === value).displayText
      }
    }
  },
  computed: {
    ...mapGetters(["exceptionSubmissionRequestData", "userData", "currentUser", "supplierContactRoleOptions"]),
    filteredRequestFor() {
      return this.getPreviewText(this.requestForOptions, 'exceptionRequestFor')
    },
    previewRequestedByFullName() {
      return this.userData(this.currentUser.userName).fullName
    },
    previewRequestedForFullName() {
      return this.userData(this.exceptionSubmissionRequestData.requestedFor).fullName
    },
    watcherList() {
      let watchersString = ''
      this.exceptionSubmissionRequestData.watchers.forEach((watcher, index) => {
        index > 0 ? watchersString += ", " : ''
        watchersString += this.userData(watcher).fullName
      })
      return watchersString
    }
  },
  data() {
    return {
      previewMultiSelectOptions: '',
      requestForOptions: EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_OPTIONS,
      requestForMap: EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP,
      requestForCheckBoxText: EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.updatePreviewMultiSelectOptions()
  },
  methods: {
  companyBuyingServiceIsUS() {
    return this.exceptionSubmissionRequestData.companyBuyingServiceCheckBox
        && this.exceptionSubmissionRequestData.companyBuyingServiceCheckBox.some(countryObj =>
            countryObj.country === EXCEPTION_SUBMISSION_CONSTANTS.COUNTRY_US)
  },
  updatePreviewMultiSelectOptions() {
    this.previewMultiSelectOptions = this.checkBoxCountriesCommaSeparated() + this.listCountriesCommaSeparated()
  },
  checkBoxCountriesCommaSeparated() {
    let countriesStr = ""
    let checkBoxCountries = this.exceptionSubmissionRequestData.companyBuyingServiceCheckBox
    if (checkBoxCountries && checkBoxCountries.length > 0) {
      countriesStr = Array.prototype.map.call(checkBoxCountries, function (item) {
        return item.text;
      }).join(", ");
    }
    return countriesStr
  },
  listCountriesCommaSeparated() {
    let countriesList = this.exceptionSubmissionRequestData.companyBuyingServices
    let countriesStr = this.checkBoxCountriesCommaSeparated().length > 0 && countriesList.length > 0 ? ", " : ""

    if (countriesList && countriesList.length > 0) {
      countriesStr += Array.prototype.map.call(countriesList, function (item) {
        return item.text;
      }).join(", ");
    }
    return countriesStr
  }
}
}
</script>

<style scoped>

</style>